import { Button, Form, Input, Modal, notification } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Enums } from '../../../shared';
import { useIssueCommandMutation } from '../../../features/courses/coursesApi';

const CourseCreateModal = ({ onCancel, isOpen }) => {
    const { t } = useTranslation();
    const [issueCommand, {}] = useIssueCommandMutation();

    const onOk = (values) => {
        const command = {
            type: Enums.COMMAND_TYPES.CREATE_COURSE,
            ...values,
        };
        issueCommand({
            command,
        })
            .unwrap()
            .then((res) => {
                notification.info({
                    message: t('workbench.courses.notifications.courseCreated'),
                    duration: 2,
                });

                onCancel();
            })
            .catch((err) => {
                notification.error({
                    message: t('workbench.courses.notifications.courseNotCreated'),
                    duration: 2,
                });
                onCancel();
            });
    };

    return (
        <Modal
            title={t('workbench.courses.createCourse')}
            open={isOpen}
            onOk={onOk}
            onCancel={onCancel}
            footer={null}
        >
            <Form
                name="create-new-course"
                initialValues={{ remember: true }}
                onFinish={onOk}
                autoComplete="off"
                layout="vertical"
            >
                <Form.Item
                    label={t('workbench.courses.create.courseName')}
                    name="title"
                    rules={[
                        {
                            required: true,
                            message: t('workbench.courses.create.courseNameMissingWarning') as string,
                        },
                    ]}
                >
                    <Input data-cy="course-catalog-create-new-name" />
                </Form.Item>
                <Form.Item>
                    <Button
                        data-cy="course-catalog-create-new-submit-button"
                        type="primary"
                        htmlType="submit"
                        style={{ float: 'right' }}
                    >
                        {t('create')}
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default CourseCreateModal;
